import { MasterButton, Modal, InputTextMaster } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useState, useContext } from "react";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  convertToValidPrice,
} from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";
import { urlUpdatePembelian } from "../../helpers";

const ModalPotongan = ({ setShowModal, setNewDataPembelianList }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const { formData, setFormData } = useContext(FormContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.potongan2 === "") {
        defaultToastError("Potongan tidak boleh kosong!");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } else {
        const api = await instance4.post(urlUpdatePembelian, {
          id: formData.id,
          potongan: convertToValidPrice(formData.potongan2),
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setNewDataPembelianList(formData.id);
        } else {
          defaultToastError(res?.message);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        }
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal title={"Potongan dalam Rp"} show={setShowModal}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container direction='row' alignItems='center'>
          <Grid item sm={12}>
            <InputTextMaster
              name='disc'
              label='Disc'
              id='disc'
              placeholder='Dalam Rupiah'
              value={formData.potongan2}
              onInput={(e) => {
                let val = e.target.value;
                setFormData({
                  ...formData,
                  potongan: convertToValidPrice(val),
                  potongan2: formatRupiah(val),
                });
              }}
              withButtonLeft={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderLeft: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderRight: "0",
                    background: "#fff",
                    padding: "0 0 0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "6px 0 0 6px",
                    fontSize: "10px",
                  }}
                >
                  Rp.
                </button>
              </InputTextMaster>
          </Grid>
        </Grid>

        <div>
          <Grid
            container
            direction='row'
            justifyContent='flex-end'
            alignItems='center'>
            <MasterButton
              className={"mt-1"}
              type='submit'
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.disabled}
              size='md'
            />
          </Grid>
        </div>
      </form>
    </Modal>
  );
};

export default ModalPotongan;
